<script>
    import { user_data } from './stores.js';
    import { onMount } from "svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import Dtemplate from "./components/detailedtemplate.svelte";
    
    export let chipsdata = [
        {s: true, t: "Single Family", i:"/img/House.svg", cbf:()=>{$user_data.propertytype = "Single Family"}},
        {s: false, t: "Condo", i:"/img/Condo.svg", cbf:()=>{$user_data.propertytype = "Condo"}},
        {s: false, t: "Multi-unit", i:"/img/Multi-Unit.svg", cbf:()=>{$user_data.propertytype = "Multi-unit"}},
    ];

    onMount(async() => {

    });

</script>

<Dtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    title="What property type would this be?"
    show_next_button={false}
    >
    <Chipscompnent
        bind:chipsdata={chipsdata}
    />
    </Progresscomponent>
</Dtemplate>

<style>

</style>